export default __webpack_public_path__ + "static/media/logo.469cc31b.svg";